import React from 'react';
import { Container } from '../../globalStyles';
import {
    TextSection,
    TextWrapper,
    Title,
    Headline,
    Description
} from './TextDisplay.elements';

function TextDisplay({ data }) {
    return (
        <TextSection>
            <Container>
                {data.map((item, index) => (
                    <TextWrapper key={index}>
                        {item.topLine && <Title>{item.topLine}</Title>}
                        {item.headline && (
                            item.headline === "Register Now" ? (
                                <a href="/register" style={{ textDecoration:"none"} }> {/* Or you can use a button instead */}
                                    <Headline style={{ cursor: 'pointer', color: '#4aa8ff' }}>
                                        {item.headline}
                                    </Headline>
                                </a>
                            ) : (
                                <Headline>{item.headline}</Headline>
                            )
                        )}
                        {item.description && <Description>{item.description}</Description>}
                    </TextWrapper>
                ))}
            </Container>
        </TextSection>
    );
}

export default TextDisplay;
